import React, {useEffect, useState} from 'react';
import style from './style.module.less'
import bottomImg from "../../../../../images/member/blue-select-bottom.png";
import selectTopImg from "../../../../../images/member/selectTop.png";
import selectBottomImg from "../../../../../images/member/selectBottom.png";
import {useDispatch, useSelector} from "react-redux";
import common from "../../../../../utils/common";
import {setActiveTicket, setCardSum} from "../../../../../reducers/member";
import Modal from "../../../../public/modal";
import ConfirmAlert from "../../../components/confirmAlert";
import Page from "../../../../public/page";

function Coupon(props) {
    const {
        ticketBgStyle,
        setAction
    } = props

    const dispatch = useDispatch();

    const {memberInfo} = useSelector(state => state.member)

    const [remarkTimes, setRemarkTimes] = useState([])          //备注的计时器
    const [remarkList, setRemarkList] = useState([])            //备注信息

    const [expiredTicketList, setExpiredTicketList] = useState([])      // 过期卡券
    const [ticketList, setTicketList] = useState([])            // 卡券列表

    const [ticketTypeList, setTicketTypeList] = useState([])     //卡券类别

    const [showRowNav, setShowRowNav] = useState(false)       // 是否展示第二行卡券分类名

    const [actInvalidData, setActInvalidData] = useState({})     // 作废数据
    const [showConfirm, setShowConfirm] = useState(false)     // 是否展示确认框

    const [searchParams, setSearchParams] = useState({
        currentPage: 1, //当前页数
        isExpired: false,
        ticket_id: 0
    })
    const [pageCount, setPageCount] = useState(0)                        //总页数
    const [total, setTotal] = useState(0)


    useEffect(() => {
        // 初始化过期卡券数据
        setExpiredTicketList([])
        setPageCount(0)

    }, [])

    useEffect(() => {

    }, [])

    useEffect(() => {
        //会员卡券详情列表
        if (searchParams.isExpired) {
            getExpiredTicketList()
        } else {
            getTicketList()
        }
    }, [searchParams])


    //会员卡券详情列表
    let getTicketList = () => {
        common.loadingStart()
        Promise.all([ticketDetail(), fetchCardSum(), fetchTicketData()]).finally(() => {
            common.loadingStop()
        })
    }

    // 获取卡券数据
    const fetchTicketData = () => {
        return new Promise((resolve, reject) => {
            common.ajax('get', '/app.php/member-api/ticket').then((res) => {
                let arr = [{
                    id: -1,
                    name: '过期',
                }]
                for (let i = 0; i < res.length; i++) {
                    let item = res[i]
                    arr.push({
                        id: item.id,
                        name: item.title,
                    })
                }

                setTicketTypeList([...arr])
                resolve()

            }).catch((err) => {
                reject()
            })
        })
    }

    //会员卡券详情列表(全部)
    const ticketDetail = () => {
        setRemarkList([])
        return new Promise((resolve, reject) => {
            common.ajax('get', '/app.php/member-api/ticket-detail/v2-page', {
                member_id: memberInfo.id,
                page: searchParams.currentPage,
                ticket_id: searchParams.ticket_id
            }).then((res) => {

                setPageCount(res.pagination.pageCount)
                setTotal(res.pagination.itemCount)

                // 将项目拆成数组
                let tmpTicketDetailList = []
                let arr = []
                for (let i = 0; i < res.ticketDetailList.length; i++) {
                    let item = res.ticketDetailList[i]

                    item.project_list = []
                    if (item.project_str.length > 0) {
                        item.project_list = item.project_str.split(',')
                    }

                    tmpTicketDetailList.push(item)

                    arr.push(item.remark)
                }

                setTicketList(tmpTicketDetailList)
                setRemarkList(arr)

                resolve()
            }).catch((err) => {
                reject()
            })
        })
    }

    //更改卡券备注
    const changeTicketRemark = (itemId, value) => {
        common.ajax('post', '/app.php/member-api/ticket-detail/update-remark', {
            member_id: memberInfo.id,
            ticket_detail_id: itemId,
            remark: value,
        })
    }

    //搜索分类卡券
    const selectTicket = (val) => {

        // 选中 过期的卡券 分类
        if (val === -1) {
            setSearchParams(({
                currentPage: 1,
                isExpired: true,
                ticket_id: val
            }))
        } else {
            setSearchParams(({
                currentPage: 1,
                isExpired: false,
                ticket_id: val
            }))
        }
    }

    // 获取已过期卡券数据（未使用）
    const getExpiredTicketList = () => {
        common.loadingStart()
        common.ajax("get", "/app.php/member-api/ticket-detail/expired", {
            member_id: memberInfo.id,
            page: searchParams.currentPage,
        }).then((res) => {
            setPageCount(res.page.pageCount)
            setTotal(res.page.itemCount)
            let infoList = []

            if (res.list.length > 0) {
                for (let i = 0; i < res.list.length; i++) {
                    let item = res.list[i]

                    item.project_list = []
                    if (item.project_str.length > 0) {
                        item.project_list = item.project_str.split(',')
                    }

                    infoList.push(item)
                }
            }

            setExpiredTicketList([...infoList])

        }).finally(() => {
            common.loadingStop()
        })
    }

    // 获取最新卡券数
    const fetchCardSum = () => {
        return new Promise((resolve, reject) => {
            common.ajax('get', '/app.php/member-api/member/sum', {id: memberInfo.id}).then((res) => {
                dispatch(setCardSum(res))        // 放入会员卡及卡券总数
                resolve()
            }).catch((err) => {
                reject()
            })
        })
    }

    // 作废卡券
    const invalid = () => {
        if (actInvalidData.key === undefined) {
            common.toast('作废数据缺失')
            return
        }

        let item = actInvalidData.item

        common.loadingStart()
        common.ajax('post', '/app.php/member-api/ticket-detail/invalid', {
            member_id: memberInfo.id,
            ticket_detail_id: item.id,
        }).then(() => {
            common.toast('作废成功')
            setShowConfirm(false)
            setActInvalidData({})
            setSearchParams({...searchParams,currentPage: 1})
        }).finally(common.loadingStop)
    }

    const showTicketItem = (item, key) => {
        return (
            <div key={key} className={style.itemDiv}
                 style={ticketBgStyle}>
                <div className={style.bgTopBox}>

                    <div className={style.ticketNameBox}>
                        <div className={style.ticketName}>{item.name}
                        </div>
                        {
                            item.money_str &&
                            <div className={style.moneyFont}><span>￥</span>{item.money_str}</div>
                        }

                    </div>

                    <div className={style.row}>
                        <div className={style.shop}>{item.user_name}</div>
                    </div>

                    <div className={style.row}>
                        <div
                            className={style.category}>限品类：{item.project_list.length > 0 ? item.project_list[0] : '不限'}</div>

                        <img className={style.bottomImg} src={bottomImg} alt=""/>

                        {
                            item.project_list.length > 0 &&
                            <div className={style.selectBox}>

                                {
                                    item.project_list.map((item, index) =>
                                        <div key={index} className={style.selectItem}>
                                            <div className={style.text}>
                                                <div>{item}</div>
                                            </div>
                                        </div>
                                    )
                                }

                                {/*<div className={'selectItem'}>*/}
                                {/*    <div className={'text'}>*/}
                                {/*        <div>三星团购全身精油开背三星团购全身精油开背</div>*/}
                                {/*        <img src={selectedImg} alt=""/>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                            </div>
                        }

                    </div>

                    <div className={style.row}>
                        <div className={style.number}>使用期限：{item.valid_str}</div>
                    </div>

                </div>


                <div className={style.bgBottomBox}>

                    <div className={style.remark}>
                        <textarea className={style.remarkInput} placeholder={'请输入备注信息'}
                                  value={remarkList[key] || ''}
                                  onChange={(e) => {
                                      let value = e.target.value
                                      remarkList[key] = value

                                      if (searchParams.isExpired) {
                                          expiredTicketList[key].remark = value // 过期卡券
                                      } else {
                                          ticketList[key].remark = value //非过期
                                      }

                                      clearTimeout(remarkTimes[key])
                                      remarkTimes[key] = setTimeout(() => {
                                          changeTicketRemark(item.id, value)
                                      }, 1000)
                                      setRemarkTimes(JSON.parse(JSON.stringify(remarkTimes)))
                                  }}></textarea>
                    </div>

                    <div className={style.btnBox}>
                        {
                            searchParams.isExpired ?
                                <span className={style.btnItem + ' ' + style.noBorder} onClick={() => {
                                    dispatch(setActiveTicket(item))
                                    setAction('putOffTicket')
                                }}>延期</span>
                                : <>
                                    <div className={style.btnItem} onClick={() => {
                                        setActInvalidData({
                                            item: item, key: key
                                        })
                                        setShowConfirm(true)
                                    }}>作废
                                    </div>
                                    <div className={style.btnItem + ' ' + style.noBorder} onClick={() => {
                                        dispatch(setActiveTicket(item))
                                        setAction('transferCoupon')
                                    }}>转赠
                                    </div>
                                </>
                        }

                    </div>
                </div>

            </div>
        )
    }

    useEffect(() => {
        // 非过期卡券
        if (!searchParams.isExpired) {
            return
        }

        let arr = []
        for (let i = 0; i < expiredTicketList.length; i++) {
            arr.push(expiredTicketList[i].remark)
        }
        setRemarkList(arr)
    }, [expiredTicketList, searchParams])

    return (
        <div className={style.Coupon}>

            {
                showConfirm && <Modal title=""
                                      closable={false}
                                      footer={false}>
                    <ConfirmAlert toastTitle={'确认作废吗'}
                                  onCancel={() => {
                                      setShowConfirm(false)
                                      setActInvalidData({})
                                  }}
                                  onOk={() => invalid()}
                    />
                </Modal>
            }

            <div className={style.couponNav}>
                <div className={style.couponContentNav}>
                    {
                        ticketTypeList.map((item, key) => {
                                if (key > 6) {
                                    return ""
                                }

                                return (
                                    <div key={key}
                                         className={[style.couponNavItem, searchParams.ticket_id === item.id && style.active].join(' ')}
                                         onClick={() => {
                                             selectTicket(item.id)
                                         }}>{item.name}{item.quantity ? '(' + item.quantity + ')' : ''}</div>
                                )
                            }
                        )
                    }
                </div>

                {
                    (ticketTypeList.length > 7 && !showRowNav) ?
                        <img className={style.selectImg} src={selectBottomImg} alt=""
                             onClick={() => setShowRowNav(true)}/>
                        : <div className={style.selectImg}></div>
                }

            </div>

            {
                (ticketTypeList.length > 7 && showRowNav) && <div className={style.couponNav}>
                    <div className={style.couponContentNav}>
                        {
                            ticketTypeList.map((item, key) => {
                                    if (key < 6) {
                                        return ""
                                    }

                                    return (
                                        <div key={key}
                                             className={[style.couponNavItem, searchParams.ticket_id === item.id && style.active].join(' ')}
                                             onClick={() => {
                                                 selectTicket(item.id)
                                             }}>{item.name}{item.quantity ? '(' + item.quantity + ')' : ''}</div>
                                    )
                                }
                            )
                        }
                    </div>

                    <img className={style.selectImg} src={selectTopImg} alt="" onClick={() => setShowRowNav(false)}/>
                </div>
            }


            <div className={style.couponContent}>
                {
                    searchParams.isExpired ?
                        expiredTicketList.map((item, key) =>
                            showTicketItem(item, key)
                        ) :
                        ticketList.map((item, key) =>
                            showTicketItem(item, key)
                        )
                }

                {
                    searchParams.currentPage >= pageCount && (
                        <div className={style.loadingFont}>暂无更多数据</div>
                    )
                }
            </div>
            {pageCount > 0 ?
                <Page
                    selectPage={false}
                    defaultCurrent={searchParams.currentPage} // 当前页码
                    pageSize={20}          // 每页数量
                    total={total}                           // 总数量
                    totalPage={pageCount}                   // 总页数
                    onChange={(num) => {                    // 点击页改变
                        setSearchParams({...searchParams, currentPage: num})
                    }}
                    pageChange={(e) => {                    // 每页数量改变
                        setSearchParams({...searchParams, pageSize: e.target.value})
                    }}
                />
                :
                null
            }
        </div>

    );
}

export default Coupon;